import store from './store';

export default function init(): Promise<any[]> {
  return Promise.all([store.dispatch('init')]);
}
